module.exports = __webpack_public_path__ + "static/img/m2.2d7794e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/center/m2.png
// module id = uLrR
// module chunks = 0